import { TMfaSessionsResult } from 'src/apps/dashboard/types/MobileDashboardServiceTypes';
import { MobileRun } from 'src/apps/dashboard/types/MobileRunsTableTypes';
import { returnNonNull } from 'src/common/helpers/ArraysHelper';

import { MobileDashboardMfaSessionsQuery } from '../MfaSessions.generated';

export const transformMfaSessionsResults = (
	rawResults: MobileDashboardMfaSessionsQuery
): TMfaSessionsResult => {
	const rows: MobileRun[] =
		rawResults.mfa_session_runs?.filter(returnNonNull).map((session) => ({
			id: session.run_id,
			name: session.session_name,
			totalIssues: session.total_issues,
			criticalIssues: session.critical_issues,
			date: session.run_updated_at
		})) ?? [];

	const total = rawResults.total?.[0]?.run_id_count ?? 0;
	const unfilteredTotal = rawResults.unfiltered_total?.[0]?.run_id_count ?? 0;

	return {
		rows,
		total,
		unfilteredTotal
	};
};
